import { api } from "./api";

export async function loadOwnerLillyCapabilities() {
  const { data } = await api.get("/owner/lilly/capabilities");
  return data;
}

export async function sendOwnerLillyMessage(message, conversationContext = null) {
  const { data } = await api.post("/owner/lilly/chat", {
    message,
    conversation_context: conversationContext,
  });
  return data;
}
